module.exports = new __parcel__URL__("About-Pic-2.fec0699c.webp").toString();